<app-base-wireframe>
  <div class="top-bar" wireframe-block="topbar" [mmTestId]="'AUTHORIZATION_PAGE.TOP_BAR'">
    <app-topbar [backLinkUrl]="(backLinkMetadata | async)?.isVisible && (backLinkMetadata | async)?.link"></app-topbar>
  </div>

  <div wireframe-block="main" [mmTestId]="'AUTHORIZATION_PAGE.MAIN'">
    <div class="authorization">
      <div class="authorization__back-link">
        <app-back-link *ngIf="(backLinkMetadata | async)?.isVisible" [link]="(backLinkMetadata | async)?.link">
          {{ (backLinkMetadata | async)?.title | translate }}
        </app-back-link>
      </div>

      <div class="authorization__header">
        <div class="authorization__title">
          <app-page-title></app-page-title>
          <ng-container *ngIf="(pageAlias$ | async).includes('validate-email')">
            <div *appHideFor="'mm-gt-mobile'" class="authorization__divider"></div>
          </ng-container>
        </div>
      </div>

      <div class="authorization__main">
        <div class="authorization__subheader authorization__larger_font authorization__validate-email"
             *ngIf="(pageAlias$ | async).includes('validate-email')">
          <ng-container *ngIf="emailExists$ | async; else loginTmpl">
            <p #email_redirect_container class="authorization__subheader-email"
               [innerHTML]="'PAGES.AUTH.EMAIL.LOGIN.REDIRECT.SUB.TITLE' | translate">
            </p>
          </ng-container>
          <ng-template #loginTmpl>
                   <span [innerHTML]="'PAGES.AUTH.EMAIL.LOGIN.OR.REGISTER.SUB.TITLE' | translate">
                    </span>
          </ng-template>

        </div>

        <div class="authorization__subheader" *ngIf="(pageAlias$ | async).includes('check-vat')">
          <p class="authorization__subheader-vat"
             [innerHTML]="'PAGES.AUTH.CHECK.VAT.SUB.TITLE' | translate">
          </p>
        </div>

        <div class="authorization__subheader authorization__subheader__magic-link-note authorization__larger_font"
             *ngIf="(pageAlias$ | async).includes('secure-login-notice')">
          <img src="{{ magicLinkIcon }}" />
          <p class="authorization__magic-link-note"
             [innerHTML]="'PAGES.AUTH.SECURE_LOGIN_NOTICE.SUBHEADER' | translate: { email: passwordlessLoginEmail }"></p>
        </div>

        <div class="authorization__subheader" *ngIf="(pageAlias$ | async).includes('passwordless-signup')">
          <p class="authorization__subheader-vat">
            {{"PAGES.AUTH.REGISTRATION_TYPE.SUBTITLE" | translate}}
          </p>
        </div>

        <div class="authorization__alert-container fn-authorization__alert-container"></div>

        <div class="authorization__content">
          <router-outlet></router-outlet>
        </div>
      </div>

      <div class="authorization__footer">
        <div class="authorization__switch">
          <ng-container [ngSwitch]="pageAlias$ | async">
            <ng-container *ngSwitchCase="'email-validation'">
            </ng-container>
            <ng-container *ngSwitchCase="'registration-type'">
            </ng-container>
            <ng-container *ngSwitchCase="'passwordless-signup'">
            </ng-container>
            <ng-container *ngSwitchCase="'add-business-details'">
            </ng-container>
            <ng-container *ngSwitchCase="'check-vat'">
            </ng-container>
            <ng-container *ngSwitchCase="'check-tax-id'">
            </ng-container>
            <ng-container *ngSwitchCase="'branch-selection'">
            </ng-container>
            <ng-container *ngSwitchCase="'registration-type-private-or-business'">
            </ng-container>
            <ng-container *ngSwitchCase="'validate-email'">
            </ng-container>
            <ng-container *ngSwitchCase="'idam-register'">
            </ng-container>
            <ng-container *ngSwitchCase="'login'">
                            <span class="authorization__switch-question" translate>
                                PAGES.AUTH.REGISTRATION_QUESTION
                            </span> <a class="authorization__switch-link"
                                       [routerLink]="registrationPageLink"
                                       queryParamsHandling="preserve"
                                       [mmTestTarget]="'link-to-login-registration'"
                                       rel="nofollow"
                                       translate>
              REGULAR.CREATE_ACCOUNT
            </a>
              <div class="authorization__notice">
                <p class="authorization__notice__text">{{ 'PAGES.AUTH.LOGIN.NOTICE' | translate}}
                </p>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'password-restoration'">
                            <span class="authorization__switch-question" translate>
                                PAGES.AUTH.REMEMBER_PASSWORD_QUESTION
                            </span> <a class="authorization__switch-link"
                                       [routerLink]="loginPageLink"
                                       queryParamsHandling="preserve"
                                       [mmTestTarget]="'link-to-login-registration'"
                                       rel="nofollow"
                                       translate>
              REGULAR.LOGIN
            </a>
            </ng-container>
            <ng-container *ngSwitchDefault>
                            <span class="authorization__switch-question" translate>
                                PAGES.AUTH.LOGIN_QUESTION
                            </span>

              <a
                class="authorization__switch-link"
                [routerLink]=""
                queryParamsHandling="preserve"
                [mmTestTarget]="'link-to-login-registration'"
                (click)="idamLogin()"
                translate>
                REGULAR.LOGIN
              </a>
            </ng-container>
            <ng-container *ngSwitchCase="'secure-login-notice'">
              <b><span class="authorization__switch-question" translate>
                                PAGES.AUTH.SECURE_LOGIN_NOTICE.CHECK_INBOX
                            </span></b><br><br>

              <div class="authorization__divider authorization__divider__magic-link-div"></div>

              <span class="authorization__login-notice" [innerHTML]="'PAGES.AUTH.SECURE_LOGIN_NOTICE.LINK_NOTE' | translate"></span>
              <a
                class="authorization__underlined-link"
                [routerLink]=""
                (click)="resendMagicLink()"
                queryParamsHandling="preserve"
                [mmTestTarget]="'link-resend-magic-email'"
                rel="nofollow"
                translate>
                PAGES.AUTH.SECURE_LOGIN_NOTICE.RESEND_LINK
              </a>
            </ng-container>
            <ng-container *ngSwitchCase="'login-flow-type'">
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</app-base-wireframe>
